import React, { Suspense } from 'react';
import { IMatchStartupFormations } from '@sky-it-livedata/livedata-sports-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const MatchStartupFormationsWrapper = React.lazy(() => import('./match-startup-formations'));
export interface IDynamicMatchStartupFormationsWrapper extends IComponentModel<IMatchStartupFormations> {
  live?: boolean;
  model: any;
}

const DynamicMatchStartupFormations: React.FC<IDynamicMatchStartupFormationsWrapper> = ({
  /* istanbul ignore next: default value on mandatory field */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  live,
}: IDynamicMatchStartupFormationsWrapper) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <MatchStartupFormationsWrapper
      initialModel={validateModel(model) as IMatchStartupFormations}
      query={validateModel(query)}
      live={live}
    />
  </Suspense>
);

DynamicMatchStartupFormations.defaultProps = {
  live: false,
};

export default DynamicMatchStartupFormations;
